<div [ngClass]="['brand-score', narrow ? 'narrow' : '']">
  @if (score != null) {
    <span>{{ addPercent(score) }}</span>
  }
</div>
